import { combineReducers } from "redux";

import myProfileReducer from "./my-profile";
import patchProfileReducer from "./patch-profile";

const reducers = combineReducers({ myProfileReducer, patchProfileReducer });

export default reducers;
